<p-dialog
  header="Impersonate Customer"
  [(visible)]="showDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px' }"
  (onHide)="closeDialog()"
>
  <div *ngIf="!loading" class="ui-g" style="position: relative">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>User</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="users"
          placeholder="Select user"
          autoWidth="false"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedUser"
          appendTo="body"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12" style="margin-top: 20px">
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        class="ui-button btn-to-right"
        (click)="closeDialog()"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-check"
        label="Impersonate"
        class="ui-button green-btn btn-to-right"
        (click)="confirmImpersonation()"
        [disabled]="!selectedUser"
      ></button>
    </div>
  </div>
</p-dialog>
